import { Card, Flex, Heading } from '@utilitywarehouse/hearth-react';

import { RetailPartner } from '@generated/gql/graphql';

import { BrandQuickAddItem } from './BrandQuickAddItem';

interface BrandQuickAddProps {
  brands: RetailPartner[];
  onSelect: (brandId: string) => void;
}

const BrandQuickAdd = ({ brands, onSelect }: BrandQuickAddProps) => {
  if (brands.length === 0) return null;
  return (
    <Card
      colorScheme="neutralSubtle"
      variant="subtle"
      direction="column"
      spacing="lg"
    >
      <Heading size="sm">Suggested brands to get started</Heading>
      <Flex spacing="md" wrap="wrap">
        {brands.map((brand) => (
          <BrandQuickAddItem
            key={brand.id}
            brand={brand}
            onClick={(brandId) => onSelect(brandId)}
          />
        ))}
      </Flex>
    </Card>
  );
};

export { BrandQuickAdd, type BrandQuickAddProps };
